export default __webpack_public_path__ + "assets/images/6b184abd9507e15cf39e646394275469.svg";